import { useEffect, useState } from 'react';
import { ProjectApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectPublicDto } from '../../../commonTypes/project.types';

const useHttpGetAllProjectsPublicFromOrganization = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const [areProjectsReady, setAreProjectsReady] = useState<boolean>(false);
    const [projects, setProjects] = useState<ProjectPublicDto[]>([]);

    const getProjects = () => {
        const { exec, abort } = projectApi.getProjectsFromOrganization({
            onSuccess: res => setProjects(res.body),
            onError: error => error,
            onFinally: () => setAreProjectsReady(true),
        });
        exec();
        return abort;
    };

    useEffect(getProjects, []);
    return { areProjectsReady, projects };
};

export default useHttpGetAllProjectsPublicFromOrganization;
